import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=4f4a13ab&"
import script from "./Pagination.vue?vue&type=script&lang=js&"
export * from "./Pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f4a13ab')) {
      api.createRecord('4f4a13ab', component.options)
    } else {
      api.reload('4f4a13ab', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=4f4a13ab&", function () {
      api.rerender('4f4a13ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Crud/Pagination.vue"
export default component.exports